// Models
import { ITopProduct } from '@/models/products.model';

export const normalizeTopProductValues = (initialValues: ITopProduct) => {
  const normalizedData = {
    product_id: initialValues?.product?.id,
  };
  return normalizedData;
};
